
































import { Component, Vue } from 'vue-property-decorator';
import Forms from '@/components/Forms.vue';
import {
    postUser,
    getUser,
    patchUser,
    getCompanies,
    getBusinessDevelopers,
} from '@/api/api';
import User from '@/models/User';
import moment from 'moment';
import Company from '../models/Company';
import get from 'lodash/get';
import countries from '@/data/countries';
import router from '@/router';
import { roles } from '@/data/roles';
import Axios from 'axios';

let user: User | null = null;

const key = process.env.VUE_APP_ACADEMY_KEY;
const url = process.env.VUE_APP_ACADEMY_URL;

async function getUserForRouter(userID: string) {
    try {
        const { data } = await getUser(+userID);
        return data;
    } catch (error) {
        return null;
    }
}

function getUserName(value: User | null) {
    if (value) {
        return `${value.lastname} ${value.firstname}`;
    }
    return null;
}

@Component({
    beforeRouteEnter: async (to, from, next) => {
        console.log(process.env)
        const { route } = router.resolve({
            name: 'users',
        });
        to.meta.breadcrumb[1].url = route.fullPath;

        if (to.params.id) {
            user = await getUserForRouter(to.params.id);

            if (user == null) {
                Vue.prototype.$vs.notify({
                    color: 'danger',
                    position: 'top-right',
                    title: 'Erreur',
                    text: `Utilisateur introuvable.`,
                });

                next({
                    name: 'users',
                });

                return;
            } else {
                to.meta.breadcrumb[2].title = getUserName(user);
            }
        }

        next();
    },
    beforeRouteUpdate: async (to, from, next) => {
        if (to.params.id) {
            user = await getUserForRouter(to.params.id);
            to.meta.breadcrumb[2].title = getUserName(user);
        }

        next();
    },
    components: {
        Forms,
    },
})
export default class UserForm extends Vue {
    user: User | null = user;
    companiesItems: Array<{ text: string; value: number }> = [];
    loading: boolean = false;
    errors: any = {};
    businessDeveloppers: Array<{ text: string; value: number }> = [];
    get type(): 'edit' | 'add' {
        return this.$route.name === 'addUser' ? 'add' : 'edit';
    }
    get items() {
        return [
            {
                name: 'civility',
                label: 'Civilité *',
                type: 'select',
                errorMessage: 'La civilité est requise',
                required: true,
                items: [
                    { text: 'Monsieur', value: 'Monsieur' },
                    { text: 'Madame', value: 'Madame' },
                ],
            },
            {
                name: 'firstname',
                label: 'Prénom *',
                type: 'text',
                errorMessage: 'Le prénom est requis',
                required: true,
            },
            {
                name: 'lastname',
                label: 'Nom *',
                type: 'text',
                errorMessage: 'Le nom est requis',
                required: true,
            },
            {
                name: 'email',
                label: 'Email *',
                type: 'text',
                errorMessage: "L'email est requis",
                required: true,
            },
            {
                name: 'password',
                label: 'Mot de passe *',
                type: 'password',
                errorMessage: 'Le mot de passe est requis',
                hidden: this.type === 'edit',
                required: true,
            },
            {
            name: 'passwordConfirmation',
            label: 'Confirmez le mot de passe *',
            type: 'password',
            errorMessage: 'Les mots de passe ne correspondent pas',
            hidden: this.type === 'edit',
            required: true,
            },

            {
                name: 'company',
                label: 'Entreprise',
                type: 'select',
                items: this.companiesItems,
            },
            {
                name: 'roles',
                label: 'Rôle *',
                type: 'select',
                multiple: true,
                required: true,
                items: [
                    { text: 'Administrateur', value: 'ROLE_ADMIN' },
                    { text: 'Prescripteur Autonome', value: 'ROLE_PRESCRIBER' },
                    { text: 'Manager', value: 'ROLE_MANAGER' },
                    { text: 'Opérateur de saisie', value: 'ROLE_OPERATOR' },
                ],
            },
            {
                name: 'business_developper',
                label: 'Business Developer *',
                type: 'select',
                items: this.businessDeveloppers,
                required: true,
            },
            {
                name: 'birthdate',
                label: 'Date de naissance',
                type: 'date',
            },
            {
                name: 'phone',
                label: 'Téléphone Fixe',
                type: 'text',
            },
            {
                name: 'mobile',
                label: 'Téléphone Mobile',
                type: 'text',
                required: true,
            },
            {
                name: 'address',
                type: 'address',
                fields: {
                    street: {
                        label: 'Adresse *',
                        name: 'street',
                        errorMessage: "L'adresse est requise",
                        required: true,
                    },
                    street2: {
                        label: `Complément d'adresse`,
                        name: 'street2',
                    },
                    postal_code: {
                        label: 'Code postal *',
                        name: 'postal_code',
                        errorMessage: 'Le code postal est requis',
                        required: true,
                    },
                    city: {
                        label: 'Ville *',
                        name: 'city',
                        errorMessage: 'La ville est requise',
                        required: true,
                    },
                },
            },
            {
                name: 'enabled',
                label: 'Vérifié',
                type: 'switch',
            },
            {
                name: 'ringover_api_key',
                label: 'Clé API Ringover',
                type: 'text',
            },
            {
                name: 'ringover_sms_number',
                label: 'Votre numéro de téléphone ringover',
                type: 'text',
            },
        ];
    }
    defaultValue: any | null = {
        civility: null,
        firstname: null,
        lastname: null,
        company: null,
        roles: null,
        email: null,
        birthdate: null,
        phone: null,
        mobile: null,
        password: null,
        passwordConfirmation: null,
        address: {
            street: null,
            street2: null,
            postal_code: null,
            city: null,
        },
        enabled: false,
        business_developper: null,
        ringover_api_key: null,
        ringover_sms_number: null
    };

    async created(): Promise<void> {
        this.loading = true;
        const dataCompanies = await getCompanies();
        const companies = dataCompanies.data;
        this.companiesItems = companies.map((item: Company) => ({
            value: item.id || 0,
            text: item.name,
        }));

        const dataBusinessDeveloppers = await getBusinessDevelopers();
        this.businessDeveloppers = dataBusinessDeveloppers.data.map(
            (item: User) => ({
                text: item.firstname + " - " + item.email,
                value: item.id || 0,
            })
        );
        if (this.type === 'edit' && this.user) {
            // defaultValue
            this.defaultValue.civility = this.user.civility || null;
            this.defaultValue.firstname = this.user.firstname || null;
            this.defaultValue.ringover_sms_number = this.user.ringover_sms_number || null;
            this.defaultValue.ringover_api_key = this.user.ringover_api_key || null;
            this.defaultValue.business_developper = this.user.business_developper || null;
            this.defaultValue.lastname = this.user.lastname || null;
            this.defaultValue.company = this.user.company
                ? this.user.company.id
                : null;
            this.defaultValue.roles =
                (this.user.roles && this.user.roles[0]) || null;
            this.defaultValue.email = this.user.email || null;
            this.defaultValue.birthdate =
                (this.user.birthdate && moment(this.user.birthdate)) || null;
            this.defaultValue.phone = this.user.phone || null;
            this.defaultValue.mobile = this.user.mobile || null;
            this.defaultValue.address.street =
                (this.user.address && this.user.address.street) || null;
            this.defaultValue.address.street2 =
                (this.user.address && this.user.address.street2) || null;
            (this.defaultValue.address.postal_code =
                (this.user.address && this.user.address.postal_code) || null),
                (this.defaultValue.address.city =
                    (this.user.address && this.user.address.city) || null);
            this.defaultValue.enabled = this.user.enabled;
        }
        this.loading = false;
    }




    async submit(form: any) {

        const $vs = (this as any).$vs;

                // 1) Mot de passe (uniquement en mode "add")
                if (this.type === 'add') {
                    if (form.password !== form.passwordConfirmation) {
                    $vs.notify({
                        color: 'danger',
                        position: 'top-right',
                        text: 'Les mots de passe ne correspondent pas'
                    });
                    return;
                    }
                }



        this.loading = true;
        const newUser: User = {
            civility: form.civility,
            firstname: form.firstname,
            lastname: form.lastname,
            company: form.company,
            roles: form.roles,
            email: form.email,
            birthdate: form.birthdate,
            password: form.password === null ? undefined : form.password,
            phone: form.phone,
            mobile: form.mobile,
            address: {
                street: form.address.street,
                street2: form.address.street2,
                postal_code: form.address.postal_code,
                city: form.address.city,
            },
            business_developper: form.business_developper,
            enabled: form.enabled,
            ringover_api_key: form.ringover_api_key,
            ringover_sms_number: form.ringover_sms_number,
            is_kochise: false
        };

        const passwordGenerated = Math.random().toString(36).slice(-8);

        const newUserAcademy: any = {
            lastname: form.lastname,
            firstname: form.firstname,
            email: form.email,
            password: form.password === null ? undefined : form.password,
            token: key
        }


        let post;
        try {
            if (this.type === 'add') {
                const { data } = await Axios.post(`${url}/api/register`, newUserAcademy, {
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json'
                    }
                });
                console.log(data);
                post = await postUser(newUser);
                $vs.notify({
                    color: 'success',
                    position: 'top-right',
                    title: 'Création',
                    text: `Création de l'utilisateur réussie`,
                });
            } else {
                post = await patchUser(+this.$route.params.id, newUser);
                $vs.notify({
                    color: 'success',
                    position: 'top-right',
                    title: 'Modification',
                    text: `Modification de l'utilisateur réussie`,
                });
            }
            if (this.$route.name === 'editPrescriber') {
                this.$router.push({ name: 'prescribers' });
            } else {
                if (form.roles[0] === "ROLE_PRESCRIBER") {
                    this.$router.push({
                        name: 'editPrescriber',
                        params: {
                            id: `${post.data.id}`,
                        },
                    })
                } else {
                    this.$router.push({ name: 'users' });
                }
            }
        } catch (error) {
            const resp = error.response && error.response.data;
            this.errors = resp && resp.errors && resp.errors.children
                ? resp.errors.children
                : {};
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: 'Erreur lors de la soumission du formulaire',
            });
        } finally {
            this.loading = false;
        }
    }
}
